import { Trans } from '@lingui/react/macro';

import { LinkButton } from '@/components/buttons';
import InstantSearchInput from '@/components/InstantSearchInput';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import { useMe } from '@/providers/User';
import { ROUTES } from '@/router';

const PixelsListHeader = () => {
  const user = useMe();

  return (
    <div className="flex items-center justify-between">
      <div>
        {user?.isAdmin && (
          <LinkButton variant="primary" to={ROUTES.pixelCreate.path}>
            <Trans>Create Pixel</Trans>
          </LinkButton>
        )}
      </div>
      <div className="flex items-center gap-2">
        <PendoPlaceholder />
        <InstantSearchInput />
      </div>
    </div>
  );
};

export default PixelsListHeader;
